import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const BoxIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Box",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M16.45 12.88c-1.93 0-3.7 1.07-4.61 2.77a5.252 5.252 0 0 0-7.76-1.75V9.52c-.08-.57-.61-.98-1.18-.9-.47.07-.84.44-.9.91v8.67c.1 2.9 2.52 5.17 5.42 5.07a5.24 5.24 0 0 0 4.42-2.71 5.243 5.243 0 0 0 7.1 2.19 5.243 5.243 0 0 0 2.19-7.1 5.24 5.24 0 0 0-4.69-2.8m-9.2 8.39a3.15 3.15 0 0 1-3.19-3.1 3.15 3.15 0 0 1 3.1-3.19 3.15 3.15 0 0 1 3.19 3.1v.04c0 1.72-1.38 3.12-3.1 3.14m9.23 0a3.15 3.15 0 0 1-3.19-3.1c-.02-1.74 1.36-3.16 3.1-3.19s3.16 1.36 3.19 3.1v.04c0 1.73-1.39 3.14-3.12 3.14m13.33.36-2.84-3.5 2.84-3.5a1 1 0 0 0-.24-1.45 1.21 1.21 0 0 0-1.58.19l-2.45 3.01-2.44-3a1.21 1.21 0 0 0-1.58-.19 1 1 0 0 0-.29 1.38c.01.02.03.04.04.06l2.84 3.5-2.84 3.5a.987.987 0 0 0 .16 1.39c.02.02.05.04.08.05.5.34 1.17.26 1.58-.19l2.45-3 2.45 2.99c.4.45 1.08.53 1.58.19.46-.29.59-.9.29-1.35-.02-.03-.04-.05-.06-.08"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M1.28 7C.61 7 .07 7.53 0 8.2v10.66c.07 3.4 2.81 6.12 6.2 6.12 2.4 0 4.46-1.34 5.46-3.34 1.07 1.93 3.13 3.34 5.46 3.34 3.4 0 6.2-2.81 6.2-6.2.07-3.46-2.74-6.26-6.14-6.26-2.4 0-4.46 1.34-5.46 3.34-1.07-1.93-3.13-3.34-5.46-3.34-1.4 0-2.65.48-3.72 1.28V8.2c0-.66-.53-1.2-1.26-1.2m29.3 5.48c-.32.03-.6.17-.8.44l-2.74 3.66-2.8-3.58c-.4-.53-1.19-.66-1.72-.2-.53.4-.68 1.19-.28 1.72l3.2 4.26-3.2 4.2c-.4.53-.25 1.32.28 1.72s1.32.33 1.72-.2l2.74-3.66 2.72 3.66c.4.53 1.21.67 1.74.2.6-.4.65-1.12.32-1.72l-3.18-4.26 3.18-4.26c.4-.53.27-1.34-.26-1.74-.26-.2-.6-.27-.92-.24M6.2 14.98c2.07 0 3.72 1.68 3.72 3.74s-1.65 3.72-3.72 3.72-3.72-1.66-3.72-3.72 1.66-3.74 3.72-3.74m10.98 0c2.07 0 3.74 1.68 3.74 3.74s-1.67 3.72-3.74 3.72-3.72-1.66-3.72-3.72 1.66-3.74 3.72-3.74"
      })
    })
  }));
};
BoxIcon.displayName = 'BoxIcon';